<template>
  <div :class="['float-label-input']">
    <label>{{ title }}</label>
    <sg-input
      :id="id"
      :name="name"
      :type="type"
      :class="[className, { 'has-danger': hasDanger, 'input-lg': size === 'lg' }]"
      :placeholder="placeholder"
      :value="value"
      :disabled="disabled"
      :required="required"
      :tabindex="tabindex"
      :icon="icon"
      :has-danger="hasDanger"
      :autofocus="autofocus"
      :autocomplete="autocomplete"
      :min="min"
      :max="max"
      @keydown.enter="$emit('keydown.enter', $event)"
      @input="$emit('input', $event)" />

    <div v-if="errorMessage" class="form_field-message">
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-xsmall"><path d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z" fill="currentColor"></path></svg>
        <span class="error-text">{{ errorMessage }}</span>
    </div>

  </div>
</template>

<script>
  import SgInput from './SgInput.vue'

  export default {

    props: {
      id: String,
      name: String,
      type: {
        type: String,
        default: 'text'
      },
      className: String,
      hasDanger: Boolean,
      placeholder: {
        type: String,
        default: ''
      },
      title: String,
      value: {
        type: String,
        required: true
      },
      disabled: Boolean,
      required: Boolean,
      tabindex: Number,
      icon: {
        type: String,
        default: ''
      },
      autofocus: Boolean,
      autocomplete: String,
      size: String,
      min: [String, Number],
      max: [String, Number],
      errorMessage: {
        type: String,
        default: null
      },
    },

    components: {
      SgInput,
    },

  }
</script>

<style lang="scss" scoped>
  @import "~sb_sass/variables";
  @import "~sb_sass/mixins";

  .float-label-input {
    position: relative;
    display: block;

    input {
      transition: .2s ease;

      &.has-icon ~ label {
        left: 3rem;
      }

    }
  }

  .error-text {
    color: $red-70;
    font-size: 14px;
  }

  .form_field-message {
    grid-column-gap: .25rem;
    grid-row-gap: .25rem;
    color: $red-70;
    justify-content: flex-start;
    align-items: center;
    margin-top: .5rem;
    display: flex;
  }
  .icon-xsmall {
    width: 1rem;
    height: 1rem;
    flex: none;
    justify-content: center;
    align-items: center;
    display: flex;
  }

</style>
